import React from 'react';
import { useState } from 'react';
import { Campaign, useCampaignChangeSalesTeamMutation } from '../../generated/graphql';
import {Alert, Button, TextField} from "@mui/material";
import {ModalWindow} from "../../components/ModalWindow";
import {SalesTeamSelect} from "../../components/MaterialSelects/SalesTeamSelect";
import WaitSpinner from "../../components/wait-spinner";
import {CampaignSelect} from "../../components/MaterialSelects/CampaignSelect";

export const CampaignChangeSalesTeam = ({ open, close }) => {
    const [source, setSource] = useState<Campaign|null>(null);
    const [destination, setDestination] = useState(null);
    const [confirmText, setConfirmText] = useState<string|null>('');
    const [newCampaign, setNewCampaign] = useState<Campaign|null>(null);
    const [error, setError] = useState(null);
    const [changeSalesTeam, changeSalesTeamStatus] = useCampaignChangeSalesTeamMutation();
    const doSubmit = async () => {
        if(!source) return;
        setError(null);
        try {
            const result = await changeSalesTeam({ variables: { campaign_id: source.id, campaign_ref: source.job_reference, sales_team_id: destination.id } });
            setNewCampaign(result?.data?.campaignChangeSalesTeam);
        } catch (e) {
            setError(e.message);
        }
    };
    const doClose = () => {
        setSource(null);
        setDestination(null);
        setConfirmText(null);
        setNewCampaign(null);
        setError(null);
        close();
    }
    const status = changeSalesTeamStatus.loading ? 'wait' : newCampaign ? 'complete' : 'ready';
    let actions:JSX.Element|null = null,
        content:JSX.Element|null=null;
    switch(status) {
        case 'ready':
            actions = <>
                <Button onClick={doClose}>Cancel</Button>
                <Button disabled={!destination || !source || confirmText != source.job_reference}
                        variant="contained"
                        onClick={doSubmit}
                >
                    Change Sales Team
                </Button>
            </>;
            content = <>
                {error &&
                    <Alert severity="error">Error: {error}</Alert>
                }
                <Alert severity="warning"><b>This action cannot undone.</b><br/>
                    Any links to the campaign (campaign previews / esignatures) will be broken.<br/>
                    Users currently editing the record will be unable to save.
                </Alert>
                <div className="grid12">
                    <CampaignSelect name="mycampaign-select" onChange={(evt) => {
                        setSource(evt.target.value)
                    }} value={source} label="Campaign to change" className="grid12-span"/>
                    <SalesTeamSelect name="destination" onChange={(evt) => {
                        setDestination(evt.target.value)
                    }} value={destination} needsAuth={false} label="New Sales Team" className="grid12-span"/>
                </div>
                {source != null && destination != null &&
                    <TextField label="Confirm by re-entering the current job reference"
                               placeholder={source?.job_reference??''} name="destination" onChange={(evt) => {
                        setConfirmText(evt.target.value)
                    }} value={confirmText}
                               error={confirmText != source.job_reference}/>
                }
            </>;
            break;
        case 'wait':
            content = <WaitSpinner variant="overlay"/>;
            break;
        case 'complete':
            content = <Alert severity="success">
                Campaign <b>{source?.name}</b> has been renamed
                from {source?.job_reference} to <b>{newCampaign?.job_reference}</b>.
            </Alert>;
            actions = <Button variant="contained" onClick={doClose}>Close</Button>;
            break;
    }
            return <ModalWindow isOpen={open} onClose={doClose}
                        header={"Change Sales Team"}
                        actions={actions}>{content}
    </ModalWindow>;
}